import { HttpCancelError } from '@cian/peperrors/shared';

/**
 * Запрос отменён (следующий вызов перебил предыдущий): HttpCancelError от httpApi
 * либо AbortError от AbortController (cancellationTokenManager).
 */
export function isRequestCancelled(error: unknown): boolean {
  return error instanceof HttpCancelError || (error instanceof Error && error.name === 'AbortError');
}
